
import Vue from 'vue'
import { Modal } from 'uiv'

export default Vue.extend({
   name: 'AddressConfirmModal',
   props: {
      visible: { type: Boolean, default: false },
      address: { type: String, default: '' },
   },
   components: {
      Modal,
   },
})
